import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// PAGES
// Login
import Login from './pages/Login';
// Logout
import Logout from './pages/Logout';
// Select company section
import CompanyDashBoard from "./pages/CompanyDashBoard";
// Recovery password
import Recovery from './pages/Recovery';
import PickingSystemV2 from "./pages/PickingSystemV2";
import WarehousePicking from "./pages/Warehouse/PickingSystem/WarehousePicking";
import SetProductStatus from "./pages/SetProductStatus";
import SalesOrderV2 from "./pages/SalesOrderV2";
import SalesOrderV3 from "./pages/SalesOrderV3/SalesOrderV3";
import ProductPricing from "./pages/ProductPricing/ProductPricing";
import SORecoveryTool from "./pages/Tools/SORecoveryTool";
import CustomerCorrectionTool from "./pages/Tools/CustomerCorrectionTool";
import CustomerPriceLevels from "./pages/ProductPricing/CustomerPriceLevels";
import InvoicesV2 from "./pages/InvoicesV2";
import CreateCustomerV2 from "./pages/CreateCustomerV2";
import CustomerList from "./pages/CustomerList";
import ShowCustomer from "./pages/ShowCustomer";
import ShowCustomerV2 from "./pages/ShowCustomerV2";
import NewCustomer from "./pages/NewCustomer";
import CustomerSpecialPricing from "./pages/SpecialCustomerPricing";
import MargenesPrecioV2 from "./pages/Reports/MargenesPreciov2";
import MargenesPrecioV3 from "./pages/Reports/MargenesPreciov3";
import TraceabilityV3 from "./pages/Reports/TraceabilityV3";
import CommissionsV3 from "./pages/Reports/CommissionsV3";
import PriceChangeReportV3 from "./pages/Reports/PriceChangeReportV3";
import CalculateNewMargin from "./pages/Reports/CalculateNewMarginPrice/MargenesPrecio";
import GeneralMarginPricesV2 from "./pages/Reports/GeneralMarginPrices/GeneralMarginPricesV2";
import Logistics from "./pages/Reports/Logistics";
import UsersManagementV3 from "./pages/UsersManagementV3/UsersManagementV3";
import Vendors from "./pages/Maintenance/Vendors";
import Purchasing from "./pages/Purchasing/Purchasing";
import ProductLines from "./pages/Maintenance/ProductLines";
import FreightModule from "./pages/Freight/FreightModule";
import LogisticsV2 from "./pages/Reports/LogisticsV2";
import CurrentShippedItemsReport from "./pages/Reports/CurrentShippedItemsReport/CurrentShippedItemsReport";
import WarehouseCurrentShippedItemsReport from "./pages/Warehouse/CurrentShippedItemsReport/CurrentShippedItemsReport";
import CurrentShippedItemsReportV3 from "./pages/Reports/CurrentShippedItemsReportV3/CurrentShippedItemsReportV3";
import CustomerBalance from "./pages/CustomerBalance";
// Dashboard for admin
import AdminLobbyV2 from "./pages/AdminLobbyV2";
import SalesLobbyV2 from "./pages/SalesLobbyV2";
import AdminDashboardTotals from "./pages/AdminDashboardTotals/AdminDashboardTotals";
// Inventory
import AddNewProduct from './pages/Inventory/AddNewProduct/AddNewProduct';
import Inventory from './pages/Inventory';
import CycleInventoryV3 from './pages/CycleInvetory';
import PromotionsView from './pages/Promotions/PromotionsView';
import AccountsReceivable from './pages/AccountsReceivable';
import PriceMarginProdLine from './pages/Inventory/PriceMarginProductLine';
import NewProductsView from './pages/Inventory/NewProductsToInclude/NewProductsView';
import NewProductsViewV3 from './pages/Inventory/NewProductsToIncludeV3/NewProductsViewV3';
import HistoryInventoryReport from './pages/Reports/HistoryInventoryReport/HistoryInventoryReport';
import ActualKPIInventory from './pages/Inventory/ActualKPIInventory/ActualKPIInventory';
// Picking
import SalesPickingSystem from './pages/SalesPickingSystem';
import WarehouseSalesPicking from './pages/Warehouse/SalesPicking/SalesPickingSystem';
// Invoices
import InvoiceV3 from "./pages/InvoiceV3";
// import ItemPriceException from './pages/ItemPriceException';
import SalesCommissionReport from './pages/Reports/SalesCommissionReport';
// Reports V2 - proper URL routes
import ShortsReport from './pages/Shorts';
import SalesReport from './pages/Reports/Sales';
import MOHReport from './pages/Reports/MOH';
import SalesByRouteReport from './pages/Reports/SalesByRoute/SalesByRoute';
import SalesOrderReport from './pages/Reports/SalesOrderReport/SalesOrderReport';
// Purchase Order
import VendorReport from './pages/Reports/VendorReport/Vendor';
import PurchaseProcessReport from './pages/Reports/Purchasing ProcessReport/PurchaseProcess';
import HistoryPurchaseOrderView from './pages/Reports/HistoryPurchaseOrder/HistoryPurchaseOrderView';
// Process logs
import QueueLogsDashboard from "./pages/QueueLogsDashboard/QueueLogsDashboard";
import QueueLogsDashboardV3 from "./pages/QueueLogsDashboardV3/QueueLogsDashboardV3";
import MyOrdersStatus from "./pages/MyOrdersStatus/MyOrdersStatus";
// Pre-sale catalog
import PreSaleCatalog from "./pages/PreSaleCatalog";
// import PreSaleSalesOrder from "./pages/PreSaleSalesOrder";
import PreSalesOrder from "./pages/PreSalesOrder";
import PreSaleOrdersList from "./pages/PreSaleOrdersList";
import PreSalePicking from "./pages/PreSalePicking";
import InvoiceMonitorButton from "./components/InvoiceMonitorButton/InvoiceMonitorButton";
import SOMonitorButton from "./components/SOMonitorButton/SOMonitorButton";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <InvoiceMonitorButton />
      <SOMonitorButton />
      <Routes>
        {/* Session */}
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/recovery" element={<Recovery />} />
        {/* Select company */}
        <Route path="/select-company" element={<CompanyDashBoard />} />
        {/* Process log queue */}
        <Route path="/process-list-mas90" element={<QueueLogsDashboard />} />
        <Route path="/process-list-mas90-v3" element={<QueueLogsDashboardV3 />} />
        <Route path="/my-orders-status" element={<MyOrdersStatus />} />
        {/* Dashboard */}
        <Route path="/admin/dashboard" element={<AdminLobbyV2 />} />
        <Route path="/sales/dashboard" element={<SalesLobbyV2 />} />
        {/* 2026-09-04 — cloned Totals tab (Altitude bug fix), isolated from AdminLobbyV2/SalesLobbyV2's shared components. Not yet linked from the menu — direct URL only until confirmed. */}
        <Route path="/admin/dashboard/totals" element={<AdminDashboardTotals />} />
        {/* Inventory */}
        <Route path="/inventory/products" element={<Inventory />} />
        <Route path="/inventory/add-new-product" element={<AddNewProduct />} />
        <Route path="/inventory/cyclical" element={<CycleInventoryV3 showMenu />} />
        <Route path="/inventory/discounts" element={<PromotionsView showMenu />} />
        <Route path="/invoices/accounts-receivable" element={<AccountsReceivable showMenu />} />
        <Route path="/inventory/price-margins" element={<PriceMarginProdLine showMenu />} />
        <Route path="/inventory/product-lines" element={<ProductLines />} />
        <Route path="/inventory/new-products" element={<NewProductsView showMenu />} />
        <Route path="/inventory/new-products-v3" element={<NewProductsViewV3 showMenu />} />
        <Route path="/inventory/history-kpi" element={<HistoryInventoryReport showMenu />} />
        <Route path="/inventory/actual-kpi" element={<ActualKPIInventory showMenu />} />
        {/* Sales Routes */}
        <Route path="/sales-orders" element={<SalesOrderV2 />} />
        <Route path="/sales-orders-v3" element={<SalesOrderV3 />} />
        {/* Price Management — standardized pricing project (2026-08) */}
        <Route path="/price-management" element={<ProductPricing />} />
        <Route path="/customer-price-levels" element={<CustomerPriceLevels />} />
        <Route path="/sales-picking-system" element={<WarehouseSalesPicking />} />
        <Route path="/sales-picking-system-v2" element={<SalesPickingSystem />} />
        <Route path="/sales-commission" element={<SalesCommissionReport showMenu />} />
        {/* Warehouse Routes */}
        <Route path="/picking-system" element={<WarehousePicking />} />
        <Route path="/picking-system-v2" element={<PickingSystemV2 />} />
        {/* Invoice Routes */}
        <Route path="/invoices" element={<InvoicesV2 />} />
        {/* Item Routes */}
        <Route path="/set-product-status" element={<SetProductStatus />} />
        {/* <Route path="/item-price-exception" element={<ItemPriceException />} /> */}
        {/* Customer Routes */}
        <Route path="/customer-list" element={<ShowCustomerV2 />} />
        {/* <Route path="/show-customer" element={<ShowCustomerV2 />} /> */}
        <Route path="/new-customer" element={<CreateCustomerV2 />} />
        <Route path="/update-customer" element={<NewCustomer />} />
        <Route path="/customer-special-pricing" element={<CustomerSpecialPricing />} />
        <Route path="/customer-balance" element={<CustomerBalance />} />
        {/* Invoices */}
        <Route path="/invoices-v3" element={<InvoiceV3 showMenu/>} />
        {/* Purchase Order */}
        <Route path="/reports/vendor-report" element={<VendorReport showMenu />} />
        <Route path="/reports/in-transit-purchase-order-report" element={<PurchaseProcessReport showMenu />} />
        <Route path="/reports/history-purchase-order-view" element={<HistoryPurchaseOrderView showMenu />} />
        {/* Pricing Routes */}
        <Route path="/price_margins" element={<MargenesPrecioV2 />} />
        <Route path="/price_margins_v3" element={<MargenesPrecioV3 />} />
        {/* Traceability & Commissions — SO/Invoice audit trail project (2026-08) */}
        <Route path="/traceability-v3" element={<TraceabilityV3 />} />
        <Route path="/commissions-v3" element={<CommissionsV3 />} />
        <Route path="/price-change-report-v3" element={<PriceChangeReportV3 />} />
        {/* Tools — SO Recovery Tool, admin-only (2026-09-25) */}
        <Route path="/tools/so-recovery-v3" element={<SORecoveryTool />} />
        {/* Tools — Customer Correction, admin-only (2026-09-25) */}
        <Route path="/tools/customer-correction-v3" element={<CustomerCorrectionTool />} />
        <Route path="/general-margin-prices" element={<GeneralMarginPricesV2 />} />
        <Route path="/calculate-new-margin" element={<CalculateNewMargin />} />
        {/* Reports */}
        <Route path="/report-logistics" element={<Logistics />} />
        <Route path="/report-current-shipped-items" element={<WarehouseCurrentShippedItemsReport showMenu />} />
        <Route path="/report-current-shipped-items-v2" element={<CurrentShippedItemsReport />} />
        <Route path="/report-current-shipped-items-v3" element={<CurrentShippedItemsReportV3 showMenu />} />
        {/* Pre-sale catalog */}
        <Route path="/pre-sales/catalog" element={<PreSaleCatalog />} />
        
        {/* Pre-sale new order V1 */}
        <Route path="/pre-sales/new-order" element={<PreSalesOrder />} />
        <Route path="/pre-sales/edit-order" element={<PreSalesOrder />} />
        {/* Pre-sale new order V2 */}
        {/* <Route path="/pre-sales/new-order" element={<PreSaleSalesOrder />} /> */}
        
        {/* Pre-sale orders */}
        <Route path="/pre-sales/orders" element={<PreSaleOrdersList />} />
        <Route path="/pre-sales/picking" element={<PreSalePicking />} />

        {/* Reports V2 - proper URL routes calling RDS mirror endpoints */}
        <Route path="/reports/shorts" element={<ShortsReport showMenu />} />
        <Route path="/reports/sales" element={<SalesReport showMenu />} />
        <Route path="/reports/moh" element={<MOHReport showMenu />} />
        <Route path="/reports/sales-by-route" element={<SalesByRouteReport showMenu />} />
        <Route path="/reports/sales-orders" element={<SalesOrderReport showMenu />} />

        {/* Freight */}
        <Route path="/freight/invoices" element={<FreightModule />} />
        <Route path="/logistics-dashboard" element={<LogisticsV2 />} />
        {/* Admin */}
        <Route path="/admin/users-management" element={<UsersManagementV3 />} />
        {/* Maintenance — Vendors & Product Lines */}
        <Route path="/purchasing/dashboard" element={<Purchasing showMenu />} />
        <Route path="/purchasing/vendors" element={<Vendors showMenu />} />

        {/* Ruta por defecto para usar el sistema show/hide V1 */}
        <Route path="/" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
